const ghostCtaLayout =
  "inline-flex items-center justify-center gap-2 rounded-full border-2 px-6 py-3";

const ghostCtaTypography =
  "text-center text-sm font-bold uppercase tracking-[0.14em]";

const ghostCtaTransition = "transition-colors duration-300";

export const ghostCtaBase = [
  ghostCtaLayout,
  ghostCtaTypography,
  ghostCtaTransition,
].join(" ");
